import { Injectable } from "@angular/core";
import { IID_RISORSA_LORA } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDRisorsaLORAStore } from "./iidRisorsaLORA.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.RISORSA_LORA)
export class IIDRisorsaLORAQuery extends AbstractInterfaceDataQuery<IID_RISORSA_LORA> {
  constructor(protected store: IIDRisorsaLORAStore) {
    super(store);
  }
}
